import { createGlobalStyle } from "styled-components";
import i18next from "i18next";

const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@300;400;500;700;800&display=swap');
*{
  direction: ${i18next.dir()};
  font-family: ${
    i18next.language === "en"
      ? "'Montserrat', sans-serif;"
      : "'Tajawal', sans-serif;"
  }
}
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: ${({ theme }) => theme.colors.background};
    font-family: ${({ theme }) => theme.fontFamily.main};
  }
`;

export default GlobalStyle;
